module.exports = __webpack_public_path__ + "e23a0bd1842a82b0cb0c1c2ff97d8908.eot";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/icons/fonts/icons.eot
// module id = 1076
// module chunks = 0